import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n.jsx";
import { PageHeader, Empty } from "../components/Bits";
import PeriodFilter, { todayRange, periodOk } from "../components/PeriodFilter";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [period, setPeriod] = useState(todayRange());
  useEffect(() => {
    if (!periodOk(period)) return;
    api.get("/audit", { params: { date_from: period.from, date_to: period.to } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [period]);
  return (
    <div data-testid="audit-page">
      <PageHeader title={t("audit")} subtitle={t("immutable_history")} />
      <PeriodFilter period={period} setPeriod={setPeriod} testid="audit-period" />
      {rows.length === 0 ? <Empty /> : (
        <div className="tactical-card divide-y divide-[var(--border)]">
          {rows.map((a) => (
            <div key={a.id} data-testid={`audit-${a.id}`} className="px-4 py-3 flex items-start gap-3 text-sm min-w-0 flex-wrap sm:flex-nowrap">
              <ScrollText size={16} className="text-[var(--amber)] mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="break-words"><span className="font-semibold">{a.user_name}</span> <span className="text-[var(--blue)] font-mono-num text-xs">{a.action}</span> <span className="text-[var(--text-3)]">{a.entity}</span></div>
                {(a.old_value || a.new_value) && (
                  <div className="text-xs text-[var(--text-3)] mt-1 font-mono-num truncate max-w-full sm:max-w-2xl">
                    {a.old_value ? `- ${JSON.stringify(a.old_value).slice(0, 80)}` : ""} {a.new_value ? `+ ${JSON.stringify(a.new_value).slice(0, 80)}` : ""}
                  </div>
                )}
                {a.reason && <div className="text-xs text-[var(--red)] mt-0.5">{a.reason}</div>}
              </div>
              <div className="text-xs text-[var(--text-3)] whitespace-nowrap shrink-0 pl-7 sm:pl-0">{new Date(a.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
